/* eslint-disable */
export default function qustionValidation(element) {

    let isErrors = false;
    const MIN_LENGTH = 3;
    const MAX_LENGTH = 500;

    element.question = element.question.length === 1 ? element.question.trim() : element.question;

    if (element.question === '') {
        element.errors['question'] = ['*Required'];
        element.errors['isError'] = true;
        isErrors = true;
    } else if (element.question.length < MIN_LENGTH) {
        element.errors['question'] = [`*Question must be more than ${MIN_LENGTH} characters`];
        element.errors['isError'] = true;

        isErrors = true;
    } else if (element.question.length > MAX_LENGTH) {
        element.errors['question'] = [`*Question must be less than ${MAX_LENGTH} characters`];
        element.errors['isError'] = true;

        isErrors = true;
    } else {
        element.errors['question'] = [];
        element.errors['isError'] = false;
        isErrors = false;
    }
    return isErrors;
}
